/**
 *  @swagger
 *  definitions:
 *    EntryRatingParams:
 *      type: object
 *      properties:
 *        EntryId:
 *          description: ID of the associated Entry
 *          type: string
 *        RatingId:
 *          description: ID of the associated Rating
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    EntryRatingCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/EntryRatingParams'
 *        - type: object
 *          required:
 *            - EntryId
 *            - RatingId
 *
 *  @swagger
 *  definitions:
 *    EntryRatingQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the EntryRating
 *              type: string
 *        - $ref: '#/definitions/EntryRatingParams'
 *
 *  @swagger
 *  definitions:
 *    EntryRatingUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/EntryRatingQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    EntryRating:
 *      allOf:
 *        - $ref: '#/definitions/EntryRatingCreateParams'
 *        - $ref: '#/definitions/EntryRatingUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      EntryRating:
 *        allOf:
 *          - $ref: '#/definitions/EntryRating'
 *          - type: object
 *            properties:
 *              Entry:
 *                description: Entry of the EntryRating
 *                $ref: '#/components/schemas/Entry'
 *              Rating:
 *                description: Rating of the EntryRating
 *                $ref: '#/components/schemas/Rating'
 */

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

export type $RelationIds = {
  EntryId: string;
  RatingId: string;
};
export type $CreateParams = $RelationIds;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$CreateParams>;

export type $Associations = {
  Entry?: $Model<'Entry'>;
  Rating?: $Model<'Rating'>;
};

export type $ModelParams = $Associations & $CreateParams & {
  id: string;
};

type $Fields = {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'EntryRating'> => {
  const EntryRating = stack.define(
    'EntryRating',
    fields(Sequelize),
    {
      tableName: 'EntryRatings',
    },
  );

  EntryRating.associate = (models: $ModelClasses) => {
    models.EntryRating.belongsTo(
      models.Entry,
      {
        as: 'Entry',
        foreignKey: 'EntryId',
      },
    );
    models.EntryRating.belongsTo(
      models.Rating,
      {
        as: 'Rating',
        foreignKey: 'RatingId',
      },
    );
  };

  return EntryRating;
});
